import React from "react";
import emailjs from "emailjs-com";

const Footer = () => {
  return (
    <div className="footer text-light text-center py-4 bg-dark">
      <small class="copyright">
        Check My Works @{" "}
        <a
          class="text-light text-link"
          href="https://github.com/Krish90s"
          rel="noreferrer"
          target="_blank"
        >
          <i className="bi bi-github mx-2" />
          GitHub
        </a>
      </small>
    </div>
  );
};

export default Footer;
